import type { TableItem } from "./TableItem"


export interface JobCard {
    // OLD Version
    jobId: string,
    timestamp: string | number,
    // PC receive time captured by the cashier when an order is ingested (e.g.
    // mobile-V1 orders, whose `timestamp` is the phone's clock and may be wrong).
    // Used as the authoritative sort/replay key — see pos.jobs.ts computeJobchain.
    pcTimestamp?: string | number,
    type: JobAction    // action type
    mode: JobMode   // table mode
    alias?: string   // table "A1", "B2", "C3", ...
    uuid: string
    title? :string
    source? : string // mobile , terminal

    // for move
    newAlias?: string,
    newUuid?: string,

    toKitchen?: boolean
    json?: string
    json2?: string


    // ================

    // NEW version
    isOpeningTable?: boolean
    isClosingTable?: boolean
    // Set on the job whenever the action empties the table (move-all / void-all /
    // pay-full). The acting terminal clears that table's billing state when true.
    isTableClosed?: boolean
    isPayAll?: boolean
    hash?: string

    isMoveAndOpeningNewTable?: boolean
    cashInitalAmount?: number
    employee?: {
        name: string,
        employeeId: string,
    }

    __items: TableItem[]
    __reason: string

    grandTotal?: number
    paymentType?: string
    // PAY only — the paid receipt's client-generated Nonce, so downstream trackers
    // (open-menu) can link their row back to the receipt that produced it.
    receiptNonce?: string
    oldAlias?: string

    nickName?: string   
    deliveryInfo?: any
    v? : string
}

export enum JobMode {
    TABLE = 1,
    TOGO = 2,
    JOB = 3,
    DELIVERY = 4,
}

export enum JobAction {
    OPEN_SHOP = 100,
    CHANGE_SHIFT = 110,
    ADD = 200,
    MOVE_TO = 310,
    MOVE_RECEIVED = 320,
    SPLIT = 330,
    SET_DISCOUNT_ITEMS = 340,
    SET_COMMENTS = 350,
    SET_PRICE = 360,
    SET_DELIVERY_INFO = 370,
    VOID = 500,
    VOID_TOPPING = 505,
    CLEAR_TABLE = 510,
    CLEAR_ALL = 520,
    PAY = 700,
    DRAWER = 999,
    CLOSE_SHOP = 900
}

export const JobActionToString: Record<JobAction, string> = {
    [JobAction.OPEN_SHOP]: 'Open Shop',
    [JobAction.CHANGE_SHIFT]: 'Change Shift',
    [JobAction.ADD]: 'Add',
    [JobAction.MOVE_TO]: 'Move To',
    [JobAction.MOVE_RECEIVED]: 'Move Received',
    [JobAction.SPLIT]: 'Split',
    [JobAction.SET_DISCOUNT_ITEMS]: 'Set Discount Items',
    [JobAction.SET_COMMENTS]: 'Set Comments',
    [JobAction.SET_PRICE]: 'Set Price',
    [JobAction.SET_DELIVERY_INFO]: 'Set Delivery Info',
    [JobAction.VOID]: 'Void',
    [JobAction.VOID_TOPPING]: 'Void Topping',
    [JobAction.CLEAR_TABLE]: 'Clear Table',
    [JobAction.CLEAR_ALL]: 'Clear All',
    [JobAction.PAY]: 'Pay',
    [JobAction.DRAWER]: 'Drawer',
    [JobAction.CLOSE_SHOP]: 'Close Shop'
}
